import { CustomButton, CustomTextInput } from '@Modules/core/components';
import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IPurgeLogFileFormMeta } from '../../containers/formHandlers/PurgeLogFileFormHandle/PurgeLogFileFormMeta';

type Props = {
  onSubmit: any,
  meta: IPurgeLogFileFormMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default React.forwardRef(function UsersProfileFormUI(
  { onSubmit, meta, isLoading, isSubmitting }: Props,
  ref: any
) {
  // const textColor = useColorModeValue('gray.500', 'gray.300');

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    reset,
  }));

  return (
    <>
      <CC.Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CC.FormControl mr="2" mb="4">
            <CustomFormControl isInvalid={!!errors[meta.startDate.name]} label={meta.startDate.label}>
              <CustomTextInput
                register={register(meta.startDate.name)}
                meta={meta.startDate}
                hasError={errors[meta.startDate.name]}
              />
            </CustomFormControl>
          </CC.FormControl>

          <CustomFormControl isInvalid={!!errors[meta.endDate.name]} label={meta.endDate.label} mb="4">
            <CustomTextInput
              register={register(meta.endDate.name)}
              meta={meta.endDate}
              hasError={errors[meta.endDate.name]}
            />
          </CustomFormControl>

          <CustomButton w="full" loading={isSubmitting} type="submit">
            Traiter
          </CustomButton>
        </form>
      </CC.Box>
    </>
  );
});
